import React from 'react';
import cs from 'classnames';
import useIsMobile from '@hooks/useIsMobile';

export function WhitePanel({
    children,
    className,
    ignorePadding = false,
    ignoreVertical = false,
    borderSizing = 'rounded-[12px]',
}: {
    children: React.ReactNode;
    className?: string;
    ignorePadding?: boolean;
    ignoreVertical?: boolean;
    borderSizing?: string;
}) {
    const isMobile = useIsMobile();
    const classNames = cs(
        `bg-white border-gray-200 border mb-3 text-passport ${isMobile ? 'min-w-[280px]' : ''} `,
        borderSizing,
        className,
        {
            ['px-3 sm:px-4 md:px-10']: !ignorePadding,
            ['py-8']: !ignoreVertical,
        },
    );
    return <div className={classNames}>{children}</div>;
}

function PanelTitle({
    children,
    className,
    defaultMargin = 'mb-2',
    textClassName = 'text-lg text-passport',
}: {
    children: React.ReactNode;
    className?: string;
    defaultMargin?: string;
    textClassName?: string;
}) {
    const classNames = cs(defaultMargin, className);
    const textClass = cs(textClassName);
    return (
        <div className={classNames}>
            <h2 className={textClass}>{children}</h2>
        </div>
    );
}
function PanelSubtitle({
    children,
    className = 'text-sm',
}: {
    children: React.ReactNode;
    className?: string;
}) {
    const classNames = cs({ [className]: className });
    return (
        <div className="mb-6 text-sm text-passport">
            <p className={classNames}>{children}</p>
        </div>
    );
}

function PanelContent({ children, className }: { children: React.ReactNode; className?: string }) {
    const classNames = cs('w-full flex flex-grow text-passport', className);

    return <div className={classNames}>{children}</div>;
}

function PanelHeadDivider({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) {
    const classNames = cs(
        'flex justify-between pb-5 border-b border-gray-200 text-passport',
        className,
    );
    return <div className={classNames}>{children}</div>;
}

WhitePanel.Title = PanelTitle;
WhitePanel.Subtitle = PanelSubtitle;
WhitePanel.Content = PanelContent;
WhitePanel.HeadDivider = PanelHeadDivider;
